export default {"src":"/_next/static/media/bullet-point.54207a86.svg","height":15,"width":15};